import { ActionType } from "../constants/coordinates";
import { eraserCalculation } from '../../helpers/Canvas/Eraser'

import {
  addTempMarkApi,
  updateTempMarkApi,
  addMarkApi,
  RemoveTempMarkApi
} from "../../api/marks/marks";


export const addCoordAction = data => dispatch => {
  return dispatch({
    type: ActionType.ADD_COORD,
    payload: data
  });
};

export const removeLastItemAction = () => dispatch => {
  return dispatch({
    type: ActionType.REMOVE_LAST_ITEM
  });
};


export const removeCoordinatesAction = erasedCoords => (dispatch, getState) => {
  const { newCoords: { newCoords } } = getState()
  const res = eraserCalculation(newCoords, erasedCoords)
  dispatch({ type: ActionType.EDIT_COORD, payload: res })
}


export const addTempMarkAction = (
  data,
  clickedCoords,
  closeModalHandler,
  title,
  id
) => dispatch => {
  return (!id ? addTempMarkApi(data) : updateTempMarkApi(id, data))
    .then(
      dispatch({
        type: ActionType.ADD_TEMP_MARKS_START
      })
    )
    .then(result => {
      dispatch({
        type: ActionType.ADD_TEMP_MARKS_SUCCESS,
        payload: result.data.item,
        item: clickedCoords,
        title: title
      });
    })
    .then(() => {
      closeModalHandler();
    })
    .catch(err => {
      dispatch({
        type: ActionType.ADD_TEMP_MARKS_ERRORS,
        payload:
          err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors
            : err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : {}
      });
    });
};

export const addMarkAction = (
  data,
  alertHandler,
  refreshHandler
) => dispatch => {
  addMarkApi(data)
    .then(
      dispatch({
        type: ActionType.ADD_MARKS_START
      })
    )
    .then(response => {
      return dispatch({
        type: ActionType.ADD_MARKS_SUCCESS,
        payload: response
      });
    })
    .then(() => {
      return alertHandler('success');
    })
    .then(() => {
      refreshHandler();
    })
    .catch(error => {
      alertHandler('error')
      dispatch({
        type: ActionType.ADD_TEMP_MARKS_ERRORS,
        payload: error.response
      });
    });
};

export const removeTempMarkAction = temp_mark_id => dispatch => {
  return RemoveTempMarkApi(temp_mark_id)
    .then(
      dispatch({
        type: ActionType.REMOVE_TEMP_MARKS_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.REMOVE_TEMP_MARKS_SUCCESS,
        payload: temp_mark_id
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.REMOVE_TEMP_MARKS_START,
        payload: error.response
      });
    });
};

export const deletePointFromModal = choosen_item => dispatch => {
  return dispatch({
    type: ActionType.DELETE_POINT_FROM_MODAL,
    payload: choosen_item
  });
};

export const deleteErrorsAction = error_name => dispatch => {
  return dispatch({
    type: ActionType.DELETE_ERRORS,
    payload: error_name
  });
};

export const removeAllErrors = () => dispatch => {
  return dispatch({
    type: ActionType.REMOVE_ERRORS
  });
};

export const addTempIdAction = () => dispatch => {
  return dispatch({
    type: ActionType.ADD_TEMP_ID
  });
};

export const removeCoordsDataAction = () => dispatch => {
  return dispatch({
    type: ActionType.REMOVE_COORDS_DATA,
  })
}
